<template>
  <div class="rock-table-button-group flex flex-wrap">
    <template
      v-for="(item, index) in options.filter((x) => !x.hidden)"
    >
      <vxe-button
        v-if="!item.hidden"
        :key="index"
        v-perm="[$route.meta.guard.permission + ':' + item.perm]"
        :status="item.status || 'primary'"
        :icon="item.icon"
        :content="
          (item.perm === 'del' ? '批量' : '') +
          permBtnName($route.meta.guard.permission + ':' + item.perm)
        "
        class="mb-12"
        @click="$emit('click', item.perm)"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { permBtnName } from "@/utils/permission";

export default {
  name: "RockTableButtonGroup",
  install(Vue) {
    Vue.component("RockTableButtonGroup", this);
  },
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      permBtnName,
    };
  },
  computed: {
    ...mapGetters({
      vxeSize: "vxeSize",
    }),
  },
};
</script>

<style scoped lang="scss">
.rock-table-button-group {
  ::v-deep .vxe-button.size--medium {
    font-size: 12px;
  }
}
</style>
